import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreApproveBannerComponent } from './components/pre-approve-banner/pre-approve-banner.component';
import { WhatsappShareModule } from '../whatsapp-share/whatsapp-share.module';
import { FbShareModule } from '../fb-share/fb-share.module';

@NgModule({
  declarations: [PreApproveBannerComponent],
  imports: [
    CommonModule,
    WhatsappShareModule,
    FbShareModule
  ],
  exports: [PreApproveBannerComponent]
})
export class PreApproveBannerModule { }
